import { DateType } from "./types/index";
import { parseDate } from "../utilities/parseHelper";
/**
 * Класс данных новостей банка.
 */
export class NewsData {

  public Title: string = '';

  public Description: string = '';

  public PublishDate: DateType = null;

  public Link: string = '';


  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  public constructor(src: any = null) {
    if (src) {
      this.Title = src.Title ?? '';
      this.Description = src.Description ?? '';
      this.Link = src.Link ?? '';
      this.PublishDate = parseDate(src.PublishDate);
    }
  }
}
